<div class="login-as">
  <button kendoButton fillMode="link" class="login-as__logout" iconClass="rc-icon-logout" (click)="logout()">
    {{ "LOGOUT" | translate | capitalize }}
  </button>

  <div class="card card-border login-as__card">
    <div class="card-title">{{ "LOGIN_AS_CLIENT" | translate | capitalize }}</div>
    <div class="card-body d-flex flex-column gap-24">
      <p class="m-0 fc-neutral-600">{{ "LOGIN_AS_CLIENT_DESCRIPTION" | translate }}</p>

      <kendo-formfield>
        <kendo-label labelCssClass="k-form-label" [for]="client" [text]="'CLIENT' | translate | uppercase" />
        <kendo-combobox
          #client
          [data]="clients.value()"
          [loading]="clients.isLoading()"
          [filterable]="true"
          [value]="selectedClient()"
          (filterChange)="clientSearch.set($event)"
          (valueChange)="selectedClient.set($event)"
          textField="name"
          valueField="@id"
          [placeholder]="'SELECT_CLIENT' | translate | capitalize">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span class="d-flex justify-content-between w-100 gap-16">
              <span>{{ dataItem.name }}</span>
              <span class="fc-neutral-500">{{ dataItem.customerNumber }}</span>
            </span>
          </ng-template>
        </kendo-combobox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label labelCssClass="k-form-label" [for]="employee" [text]="'CLIENT_EMPLOYEE' | translate | uppercase" />
        <kendo-combobox
          #employee
          [data]="filteredEmployees()"
          [loading]="employees.isLoading()"
          [disabled]="!selectedClient()"
          [filterable]="true"
          [value]="selectedEmployee()"
          (filterChange)="employeeSearch.set($event)"
          (valueChange)="selectedEmployee.set($event)"
          textField="fullName"
          valueField="@id"
          [placeholder]="'SELECT_EMPLOYEE' | translate | capitalize">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span class="d-flex flex-column">
              <span>{{ dataItem.fullName }}</span>
              <span class="fs-12 fc-neutral-500">
                {{ dataItem.user ? dataItem.primaryEmailAddress : ("NO_USER_ACCOUNT" | translate) }}
              </span>
            </span>
          </ng-template>
        </kendo-combobox>
      </kendo-formfield>

      <button kendoButton themeColor="primary" [disabled]="!selectedEmployee()" (click)="loginAs()">
        {{ "LOGIN_AS" | translate | capitalize }}{{ selectedEmployee() ? " " + selectedEmployee()!.fullName : "" }}
      </button>
    </div>
  </div>
</div>
